import React from 'react';
import BackBtn from '../../Button/BackBtn';
import Spacing from '../../Spacing';
import { CalendarCheck2, Search } from 'lucide-react';
import Filter from '../../Filter';
import HighRiskPatientsDataTable from '../../DataTable/HighRiskPatientsDataTable';
import DataTablePagination from '../../DataTablePagination';

export default function ConfirmedAppointments() {
  return (
    <div>
      <BackBtn href="/frontdesks-dashboard" btnText="Back to home" />
      <Spacing lg="0" sm="24" />
      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24">
          <i
            className="docpro_white_color"
            style={{ backgroundColor: '#898E87' }}
          >
            <CalendarCheck2 width={18} height={18} />
          </i>
          Confirmed appointments
          <span>3,704</span>
        </h2>
      </div>
      <Spacing lg="15" sm="15" />
      <div className="docpro_data_table_wrap">
        <div className="docpro_data_table_headings">
          <form className="docpro_search_form">
            <input
              type="text"
              placeholder="Search"
              className="docpro_search_input"
            />
            <button className="docpro_search_btn">
              <Search width={20} height={20} />
            </button>
          </form>
          <Filter filterType="advance" />
        </div>

        <HighRiskPatientsDataTable />
        <DataTablePagination />
      </div>
    </div>
  );
}
